import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index.js';

import { getTranslation } from '../../../utils';
import './style.scss';

export default function robot(data) {
  console.log('robot', data);
  /* Render message from Bot */
  const param = {
    name: 'robot',
    mid: data.mid,
    isFollow: data.isFollow,
    content: data.text,
    side: data.side || 'left',
  };
  const $node = $(BaseUI.msg(param));

  if (data.extraParams && data.extraParams.orderSelectSource === 'command') {
    // todo
  }

  if (data.showLiveagent && !this.shortcuts.agentHidden) {
    // Trigger live agent shortcut
    const liveAgent = getTranslation('csc.shortcut.liveagent');
    const shortcuts = [
      { code: 'liveAgent', icon: 'service', text: liveAgent, type: 'text', title: liveAgent, content: liveAgent },
      ...(this.essentials.config.config.shortcuts || []),
    ];
    this.appendMessage({
      type: 'dynamic_shortcuts',
      body: {
        isAdd: false,
        shortcuts,
      },
    });
  }

  $node.find('a').on('tap', (ev) => {
    const $target = $(ev.currentTarget);
    this.util.openWindow($target.attr('href'));
  });

  this.view.body.scrollToBottom();

  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/robot/index.js